import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createManager } from 'utils/redux-injectors';
import { userDetailPageSaga } from './saga';
import { UserDetailPageState, UpdateUserDetailAction } from './types';
import { User, UserPageCompanyInfo } from 'types/models';

export const initialState: UserDetailPageState = {
  user: null,
  userCompany: null,
  loading: true,
  error: false,
};

const slice = createSlice({
  name: 'userDetailPage',
  initialState,
  reducers: {
    fetchUserDetail: (state, action: PayloadAction<string>) => initialState,
    fetchUserDetailSucceeded(state, action: PayloadAction<User>) {
      state.loading = false;
      state.error = false;
      state.user = action.payload;
    },
    fetchUserDetailFailed(state) {
      state.loading = false;
      state.error = true;
      state.user = null;
    },
    fetchUserPageCompanyInfo: (state, action: PayloadAction<string>) =>
      initialState,
    fetchUserPageCompanyInfoSucceeded(
      state,
      action: PayloadAction<UserPageCompanyInfo>,
    ) {
      state.userCompany = action.payload;
    },
    fetchUserPageCompanyInfoFailed(state) {
      state.userCompany = null;
    },
    updateUserDetail(state, action: PayloadAction<UpdateUserDetailAction>) {
      //TODO:When need loading on save, can hook logic here.
    },
    updateUserDetailSucceeded(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    cleanup: () => initialState,
  },
});

export const {
  actions: userDetailPageActions,
  reducer: userDetailPageReducers,
} = slice;

export const useUserDetailPageSlice = () => ({ actions: slice.actions });

export const UserDetailPageManager = createManager({
  name: `${slice.name}Manager`,
  key: slice.name,
  reducer: slice.reducer,
  saga: userDetailPageSaga,
});

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useUserDetailPageSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
